import React from 'react';
import MypageScheduleWaitingWrapper from 'components/MypageScheduleWaitingWrapper/MypageScheduleWaitingWrapper';

export default function MypageScheduleWaitingContainer() {
    return (
        <MypageScheduleWaitingWrapper />
    )
}
